import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  Create,
  CreateProps,
  useTranslate,
  SimpleForm,
  TextInput,
  Toolbar,
  ToolbarProps,
  SaveButton,
  ListButton,
} from 'react-admin'
import { EngineMediaPackDto } from '../../../../core/dto/engine-media/engine-media-pack.dto'

const validateEngineMediaPackCreate = (values: EngineMediaPackDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.description) {
    errors.description = 'ra.validation.required'
  }
  return errors
}

const CreateTitle = () => {
  const translate = useTranslate()
  return <span>{translate('resources.engine-media-packs.titles.create')}</span>
}

const CreateToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ListButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const EngineMediaPackCreate = (props: CreateProps) => (
  <Create {...props} hasShow={false} title={<CreateTitle />}>
    <SimpleForm
      redirect="show"
      toolbar={<CreateToolbar />}
      validate={validateEngineMediaPackCreate}
    >
      <TextInput source="description" />
    </SimpleForm>
  </Create>
)
